import { render } from "./QuranView.vue?vue&type=template&id=6072d9a4"
import script from "./QuranView.vue?vue&type=script&lang=js"
export * from "./QuranView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\pwa-tahlil\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__